module.exports = __webpack_public_path__ + "img/tour-18.f7efd1cd.png";